var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1F9CF0",
    d: "m6.317 22.046-.629-.314 3.981-4.266.938 1.005-4.29 3.575zM20 25.602 5.688 10.268l.599-.299L20 22.54v3.062zm0-14.958-5.247 4.372-1.507-1.382L20 6.398v4.246zm6 13.189-4 2.4V5.766l4 2.4v15.667z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0065A9",
    d: "m27.515 6.743-6-3.6c-.027-.016-.057-.024-.086-.037-.397-.238-.91-.195-1.239.157l-8.419 9.021-4.64-4.254a1.003 1.003 0 0 0-1.123-.157L3.597 9.078a1.001 1.001 0 0 0-.284 1.576L8.302 16l-4.989 5.346a.999.999 0 0 0 .284 1.576l2.411 1.206a.997.997 0 0 0 1.088-.127l4.879-4.066 8.215 8.802a.998.998 0 0 0 .731.318.994.994 0 0 0 .52-.167c.024-.012.05-.017.073-.031l6-3.6A1 1 0 0 0 28 24.4V7.6a1 1 0 0 0-.485-.857zM6.317 22.046l-.629-.314 3.981-4.266.938 1.005-4.29 3.575zM20 25.602 5.688 10.268l.599-.299L20 22.54v3.062zm0-5.776-3.759-3.446L20 13.248v6.578zm0-9.182-5.247 4.372-1.507-1.382L20 6.398v4.246zm6 13.189-4 2.4V5.766l4 2.4v15.667z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVs);
export default __webpack_public_path__ + "static/media/VS.0266fd4c63d889d7156be854108ae906.svg";
export { ForwardRef as ReactComponent };